import { Box, Typography, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function PotionWalletCard({ potions, tamil, isLoading, isError }) {
  const theme = useTheme();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "90%",
          padding: 2,
        }}
      >
        <CircularProgress
          size={24}
          sx={{ color: theme.system.colors.text.primary }}
        />
      </Box>
    );
  }

  if (isError) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: 6,
        width: "90%",
        padding: 2,
        marginTop: 1,
        marginBottom: 2,
      }}
    >
      {/* ポーション column */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        <Typography
          sx={{
            fontFamily: theme.system.fonts.heading,
            fontSize: "20px",
            fontWeight: 700,
            color: theme.system.colors.text.primary,
            textAlign: "center",
            whiteSpace: "nowrap",
            WebkitTextStroke: "2px #FFFFFF",
            paintOrder: "stroke fill",
          }}
        >
          ポーション
        </Typography>
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/potion/potion_icon.webp`}
          alt="ポーション"
          sx={{
            width: 64,
            height: 74,
            objectFit: "contain",
          }}
          onError={(e) => {
            e.target.src = `${process.env.PUBLIC_URL}/potion/potion_icon.png`;
          }}
        />
        <Typography
          sx={{
            fontFamily: theme.system.fonts.body,
            fontSize: "30px",
            fontWeight: 500,
            lineHeight: "35px",
            textAlign: "center",
            letterSpacing: "0.1em",
            color: theme.system.colors.text.primary,
          }}
        >
          {potions}
          <Typography
            component="span"
            sx={{
              fontFamily: theme.system.fonts.body,
              fontSize: "20px",
              fontWeight: 500,
              color: theme.system.colors.text.primary,
            }}
          >
            個
          </Typography>
        </Typography>
      </Box>

      {/* 財産 column */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        <Typography
          sx={{
            fontFamily: theme.system.fonts.heading,
            fontSize: "20px",
            fontWeight: 700,
            color: theme.system.colors.text.primary,
            textAlign: "center",
            WebkitTextStroke: "2px #FFFFFF",
            paintOrder: "stroke fill",
          }}
        >
          財産
        </Typography>
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/potion/coin_icon.webp`}
          alt="財産"
          sx={{
            width: 69,
            height: 74,
            objectFit: "contain",
          }}
          onError={(e) => {
            e.target.src = `${process.env.PUBLIC_URL}/potion/coin_icon.png`;
          }}
        />
        <Typography
          sx={{
            fontFamily: theme.system.fonts.body,
            fontSize: "30px",
            fontWeight: 500,
            lineHeight: "35px",
            textAlign: "center",
            letterSpacing: "0.1em",
            whiteSpace: "nowrap",
            color: theme.system.colors.text.primary,
          }}
        >
          {tamil}
          <Typography
            component="span"
            sx={{
              fontFamily: theme.system.fonts.body,
              fontSize: "20px",
              fontWeight: 500,
              color: theme.system.colors.text.primary,
            }}
          >
            タミル
          </Typography>
        </Typography>
      </Box>
    </Box>
  );
}

export default PotionWalletCard;
